import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import ProjectEditor from "./pages/ProjectEditor";
import UserProjects from "./pages/UserProjects";
import PasswordRecovery from "./pages/PasswordRecovery";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-[#9CA3AF]"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/cadastro" element={<AuthPage mode="register" />} />
            <Route path="/recuperar-senha" element={<PasswordRecovery />} />
            <Route path="/redefinir-senha" element={<PasswordRecovery />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/projeto/:id" element={<Protected><ProjectEditor /></Protected>} />
            <Route path="/admin/usuario/:uid" element={<Protected><UserProjects /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
